import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Window } from './Window';

const RecycleBinContent = styled.div`
  padding: 10px;
  height: calc(100% - 25px);
  background: white;
  font-family: 'VT323', monospace;
`;

const FileItem = styled.div`
  padding: 5px;
  cursor: pointer;
  &:hover {
    background: #000080;
    color: white;
  }
`;

const scroll = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
`;

const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  background: #000000;
  padding: 5px 0;
  margin: 10px 0;
`;

const MarqueeContent = styled.div`
  display: inline-block;
  white-space: nowrap;
  animation: ${scroll} 20s linear infinite;
  color: #ff00ff;
`;

const WebpageContent = styled.div`
  padding: 20px;
  background: #ff00ff;
  height: 100%;
  overflow-y: auto;
  font-family: 'Comic Sans MS', cursive;
  background-image: url('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'), 
                    url('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
  color: #00ff00;
  text-shadow: 2px 2px #ff0000;
`;

const BlinkingText = styled.div`
  animation: blink 1s infinite;
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  }
`;

export const RecycleBinWindow = ({ 
  onClose, 
  isActive, 
  onActivate,
  isMinimized,
  isMaximized,
  onMinimize,
  onMaximize,
  initialPosition
}) => {
  const [showWebpage, setShowWebpage] = useState(false);

  const websiteContent = `
    <div style="text-align: center;">
      <h1 style="font-size: 48px; color: #ff0000;">🚀 DAVIDCOIN PROPOSAL 🚀</h1>
      
      <MarqueeContainer>
        <MarqueeContent>
          🌟 brought to you by KEISER VENTURES 🌟
        </MarqueeContent>
      </MarqueeContainer>

      <div style="border: 5px dashed #00ff00; padding: 20px; margin: 20px;">
        <h2>💎 THE OPPORTUNITY OF A LIFETIME 💎</h2>
        <ul style="list-style-type: none;">
          <li>✨ we create DavidCoin</li>
          <li>🌈 u get lambo</li>
        </ul>
      </div>

      <div style="background: #000000; color: #00ff00; padding: 10px; margin: 20px;">
        <h2>🚨 THE MASTER PLAN 🚨</h2>
        <p>Step 1: Launch DavidCoin</p>
        <p>Step 2: ??? </p>
        <p>Step 3: PROFIT!!!</p>
        <p style="font-size: 24px;">Only 999,999 ETH required from you!</p>
        <p style="font-size: 12px;">from the team behind $LIBRA & other scamcoins</p>
      </div>

      <div style="border: 3px solid #ff00ff; padding: 10px;">
        <h3>🏆 Why This Will Work 🏆</h3>
        <p>- based token</p>
        <p>- it's on the blockchain</p>
      </div>

      <BlinkingText style="margin: 20px; font-size: 24px; color: #ffff00;">
        🔥 LIMITED TIME OFFER: Respond within 24 hours and get a free NFT of this proposal! 🔥
      </BlinkingText>

      <div style="margin-top: 20px;">
        <p>© 2024 Kelsier Ventures</p>
        <p style="font-size: 10px;">Best viewed in Netscape Navigator while wearing sunglasses</p>
      </div>
    </div>
  `;

  return (
    <Window
      title={showWebpage ? "kelsier_ventures_pitch_deck.html" : "Recycle Bin"}
      onClose={onClose}
      isActive={isActive}
      onActivate={onActivate}
      defaultWidth="600px"
      defaultHeight="400px"
      isMinimized={isMinimized}
      isMaximized={isMaximized}
      onMinimize={onMinimize}
      onMaximize={onMaximize}
      initialPosition={initialPosition}
    >
      {!showWebpage ? (
        <RecycleBinContent>
          <FileItem onClick={() => setShowWebpage(true)}>
            kelsier_ventures_pitch_deck.html
          </FileItem>
          <FileItem>counterstrike.exe</FileItem>
        </RecycleBinContent>
      ) : (
        <WebpageContent>
          <div dangerouslySetInnerHTML={{ __html: websiteContent }} />
          <MarqueeContainer>
            <MarqueeContent>
              💰 DON'T MISS OUT ON THE NEXT BIG THING IN CRYPTO 💰
            </MarqueeContent>
          </MarqueeContainer>
          <button 
            style={{ 
              marginTop: '20px',
              background: '#00ff00',
              color: '#ff00ff',
              border: '3px solid #ff0000',
              padding: '5px 10px',
              cursor: 'pointer'
            }} 
            onClick={() => setShowWebpage(false)}
          >
            Back to Recycle Bin
          </button>
        </WebpageContent>
      )}
    </Window>
  );
}; 